import type { DatasetUploadStatus } from "@/api";

/**
 * 업로드 잡 상태를 태그 어휘로 바꾼다. 업로드 현황 목록과 admin 멈춘 업로드 목록이 같은 어휘를
 * 쓰도록 이 한 곳에서만 정의한다. 두 곳에서 따로 정의하면 같은 상태를 다른 말로 부르게 된다.
 *
 * 좁은 상태 컬럼의 배지에 표시하므로 문장이 아니라 짧은 명사구로 쓴다. 문장형 진행 안내는
 * 업로드 창이 `src/page/upload/uploadJobStatus.ts` 에서 따로 소유한다.
 */
export const UPLOAD_STATUS_LABELS: Record<DatasetUploadStatus, string> = {
  pending_upload: "업로드 미완료",
  uploaded: "처리 대기",
  fetching: "수집 중",
  probing: "확인 중",
  validating: "검증 중",
  migrating: "마이그레이션 중",
  publishing: "반영 중",
  done: "완료",
  failed: "실패",
  duplicate_skipped: "중복 건너뜀",
  conflict: "충돌",
  cancelled: "취소됨",
};
